import {ICurrencyService} from './currency.service.interface';
import {ServiceBase} from '../ServiceBase';
import {CURRENCY_SYMBOLS} from "./currency-symbol.interface";

export class CurrencyService extends ServiceBase implements ICurrencyService {

  formatMoney(value: number, withDecimal?: boolean): string {
    return this.services.sdk.formatMoney(value, withDecimal);
  }

  // TODO: Check if formatMinMaxBet can be called with undefined/null
  // after switching to strictNullCheck and repair the signature and code
  formatMinMaxBet(minBet: number, maxBet: number): string | null {
    if(minBet && maxBet) {
      return this.formatMoney(minBet, true) + ' - ' + this.formatMoney(maxBet, true);
    } else {
      return null;
    }
  }

  get currencyIso3(): string {
    return this.services.sdk.getCurrencyIso3();
  }

  get getCurrencySymbol(): string {
    return CURRENCY_SYMBOLS[this.currencyIso3] || this.currencyIso3;
  }
}
